import React from "react";
import "./Exercise.css";

const Exercise = ({ cart }) => {
  let TotalTime = 0;
  for (const book of cart) {
    TotalTime = TotalTime + book.time;
  }
  return (
    <div>
      <h6>Exercise Details</h6>
      <div className="exercise p-3 d-flex justify-content-between">
        <span className="fw-bold">Exercise time</span>
        <span className="me-3 text-secondary">{TotalTime} hours</span>
      </div>
    </div>
  );
};

export default Exercise;
